import MyLibraryRoutes from '@/pages/MyLibrary/MyLibraryRoutes';
import ModuleRoutes, {
  ModuleSetupRoutes,
  ModuleResourcesRoutes,
  ModuleSlideRoutes,
} from '@/pages/Module/routes';
import DraftRoutes from '@/pages/Draft/routes';
import PreviewRoutes from '@/pages/Preview/routes';
import ReviewRoutes from '@/pages/Review/routes';
import LiveRoutes from '@/pages/Live/routes';
import ScormRoutes from '@/pages/Scorm/routes';
import BreatheLaunchRoutes from '@/pages/BreatheLaunch/routes';
import ElearningReviewersRoutes from '@/pages/Module/Reviewers/routes';

import QuizRoutes from '@/pages/Quiz/routes';
import { RouteType } from '@/lib/route';
import PreviewReviewRoutes from '@/pages/PreviewReview/routes';
import QuizFeedbackRoutes from '@/pages/Quiz/ResultFeedback/routes';
import QuizQuestionsRoutes from '@/pages/Quiz/Questions/routes';
import PreviewQuizRoutes from '@/pages/PreviewQuiz/routes';
import PreviewLiveRoutes from '@/pages/PreviewLive/routes';
import CourseLibraryRoutes from '@/pages/CourseLibrary/CourseLibraryRoutes';
import { SettingsBaseRoutes } from '@/pages/Settings/SettingRoutes';
import SettingsThemeSelectedRoutes from '@/pages/Themes/themeRoute';
import PreviewThemeRoutes from '@/pages/PreviewTheme/routes';
import PreviewFeedbackRoutes from '@/pages/PreviewFeedback/route';
import PreviewFeedbackResultRoutes from '@/pages/PreviewFeedbackResult/route';
import VideoLibraryRoutes from '@/pages/VideoLibrary/VideoLibraryRoutes';
import SettingsTemplateSelectedRoutes from '@/pages/Templates/templateRoute';
import ContentManagerBaseRoutes, {
  ContentManagerCategoryRoutes,
} from '@/pages/ContentManager/ContentManagerRoutes';

export const pageRoutes = {
  myElearnings: MyLibraryRoutes,
  courseLibrary: CourseLibraryRoutes,
  videoLibrary: VideoLibraryRoutes,

  moduleSetup: ModuleSetupRoutes,
  moduleResources: ModuleResourcesRoutes,
  moduleSlide: ModuleSlideRoutes,
  module: ModuleRoutes,

  moduleReviewers: ElearningReviewersRoutes,

  quizFeedback: QuizFeedbackRoutes,
  quizQuestions: QuizQuestionsRoutes,
  quiz: QuizRoutes,
  SettingsThemeSelected: SettingsThemeSelectedRoutes,
  SettingsTemplateSelected: SettingsTemplateSelectedRoutes,
  Settings: SettingsBaseRoutes,

  ContentManagerCategory: ContentManagerCategoryRoutes,
  ContentManager: ContentManagerBaseRoutes,
};

export const playerRoutes: { [k: string]: RouteType } = {
  draft: DraftRoutes,
  preview: PreviewRoutes,
  previewFeedback: PreviewFeedbackRoutes,
  PreviewFeedbackResult: PreviewFeedbackResultRoutes,
  previewTheme: PreviewThemeRoutes,
  previewReview: PreviewReviewRoutes,
  previewLive: PreviewLiveRoutes,
  previewQuiz: PreviewQuizRoutes,
  review: ReviewRoutes,
  live: LiveRoutes,
  scorm: ScormRoutes,
  breatheLaunch: BreatheLaunchRoutes,
};

// To redirect root to the path below
const rootRedirect: RouteType = {
  path: '/',
  redirectTo: MyLibraryRoutes.path,
};

// To redirect the path that doesn't match any routes to the path below
const defaultRedirect: RouteType = {
  path: '*',
  redirectTo: MyLibraryRoutes.path,
};

export const appRoutes = {
  ...pageRoutes,
  ...playerRoutes,
  rootRedirect,
  defaultRedirect,
};

export default appRoutes;
